export const DEFAULT_HISTORICAL_NAME = 'Microbiology result';
